<template>
  <div>
    <div class="row">
      <div class="col-8">
        <simple-table title="Packages"
                      url="/entity/packages"
                      :columns="tableColumns"
                      :actions="actions"
                      :is-entity="true"
                      @clearScreen="closeViewPanel()"></simple-table>
      </div>
      <div class="col-4" v-if="hasPackage">
        <card>
          <template slot="header">
            <h4 class="card-title">
              View package:
              <button class="btn btn-danger pull-right" @click="closeViewPanel">
                Close
              </button>
            </h4>
          </template>
          <fg-input label="Package Name"
                    type="text"
                    v-model="pkg.name"
                    :disabled="true"
                    placeholder="Package Name">
          </fg-input>
          <fg-input label="Publisher"
                    type="text"
                    :value="`${pkg.Publisher.fullName} (${pkg.Publisher.username})`"
                    :disabled="true"
                    placeholder="Publisher">
          </fg-input>
          <fg-input label="Initial Publish Date"
                    type="text"
                    :value="parseDate(pkg.createdAt)"
                    :disabled="true"
                    placeholder="Initial Publish Date">
          </fg-input>
          <fg-input label="Last Update"
                    type="text"
                    :value="parseDate(pkg.updatedAt)"
                    :disabled="true"
                    placeholder="Last Update">
          </fg-input>
          <fg-input label="Organization"
                    type="text"
                    :value="pkg.Organization ? pkg.Organization.name : '-'"
                    :disabled="true"
                    placeholder="Organization">
          </fg-input>
          <l-checkbox :checked="pkg.public">
            Is Public
          </l-checkbox>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import SimpleTable from "../../../components/Beast/Table/SimpleTable.vue";
import LCheckbox from "../../../components/Inputs/Checkbox.vue";

export default {
  components: {
    LCheckbox,
    SimpleTable,
  },
  computed: {
    hasPackage() {
      return Object.keys(this.pkg).length > 0;
    }
  },
  data() {
    return {
      pkg: {},
      tableColumns: [
        {
          label: "Package Name",
          minWidth: 100,
          field: "name"
        },
        {
          label: "Organization",
          minWidth: 100,
          field: "Organization.name"
        },
        {
          label: "Publisher",
          minWidth: 50,
          field: "Publisher.username",
          template: value => `<a href='/users/management/${value}' class="btn btn-link text-success">${value}</a>`
        },
        {
          label: "Last Update",
          minWidth: 50,
          field: "updatedAt",
          template: value => moment(value).format("DD.MM.YYYY HH:mm:ss")
        }
      ],
      actions: [
        {
          label: "View",
          icon: "search",
          class: "btn-link text-info",
          action: (item) => {
            this.pkg = item;
          }
        },
        {
          label: "Delete",
          icon: "times",
          class: "btn-link text-danger",
          key: "id",
          value: "name",
          delete: true
        }
      ]
    };
  },
  methods: {
    closeViewPanel() {
      this.pkg = {};
    },

    parseDate(date) {
      return moment(date).format("DD.MM.YYYY HH:mm:ss");
    }
  }
};
</script>
<style scoped>
</style>
